import React from 'react';

import gilRabbiImage from 'assets/images/about/gil-rabbi.jpg';
import PageLayout from 'components/common/PageLayout';
import {
  ENTERPRISE_CONTACT_LINK,
  GIL_ROUTE,
} from 'components/constants';

import css from './About.module.scss';

const journey = [
  {
    year: '2005',
    title: 'Deep product expertise',
    text: 'Our roots began in designing high-scale digital experiences for leading media companies, banks, telecoms and global brands.',
  },
  {
    year: '2018',
    title: 'A repeatable enterprise problem',
    text: 'We saw organizations rebuilding the same engagement and data mechanics for every product, so we created a system that could scale them.',
  },
  {
    year: 'Today',
    title: 'One enterprise operating layer',
    text: 'Storycards gives organizations one place to create, govern, measure and continuously improve every interactive product.',
  },
];

const platformPillars = [
  {
    number: '01',
    title: 'Create',
    text: 'Turn prompts, ideas and data into complete, pixel-perfect interactive products.',
  },
  {
    number: '02',
    title: 'Operate',
    text: 'Manage teams, brands, permissions and live product portfolios from one governed platform.',
  },
  {
    number: '03',
    title: 'Improve',
    text: 'Turn every interaction into structured data and continuously optimize performance.',
  },
];

//   useEffect(() => {
//     const gilLinkId = document.getElementById('gilLink');
//     if (gilLinkId && gilLinkId.style) {
//       gilLinkId.style.textDecoration = 'underline';
//     }
//   }, []);

//   SwiperCore.use([Autoplay, EffectFade]);

//   return (
//     <PageLayout className={css.about}>
//       <h1 className={cn(css.pageTitle, 'text-center', 'font-semibold')}>{_t('title')}</h1>
//       <section className={css.hero}>
//         <Swiper autoplay loop speed={1000} effect="fade" className={css.heroSlider}>
//           {[images.hero, images.hero, images.hero].map((src, index) => {
//             return (
//               <SwiperSlide className={css.heroSlide} key={`${src}_${index}`}>
//                 <div className={css.heroImg} style={{ backgroundImage: `url(${src})` }} />
//               </SwiperSlide>
//             );
//           })}
//         </Swiper>
//         <p className={css.textTitle}>{_t('hero')}</p>
//       </section>
//       <section className={cn(css.company)}>
//         <div className={cn(css.s1, 'grid')}>
//           <div>
//             <p className={cn(css.textTitle, 'font-semibold')}>{_t('company.t1')}</p>
//             <p className={cn(css.textTitle, 'font-semibold')}>{_t('company.t2')}</p>
//           </div>
//           <div>
//             <p className="">{_t('company.p1')}</p>
//             <p className="">{_t('company.p2')}</p>
//             <p className="">{_t('company.p3')}</p>
//           </div>
//         </div>
//         <div className={cn(css.s2, 'grid')}>
//           <p className={cn(css.textTitle, 'font-semibold')}>{_t('company.t3')}</p>
//           <p>{_t('company.p4')}</p>
//         </div>
//       </section>
//       <section className={cn(css.ceo)}>
//         <div className={cn(css.grid, 'grid', 'grid-cols-2')}>
//           <div className={css.col1}>
//             <img className={cn(css.ceoImg)} src={images.ceo} alt="CEO: Gil Rabbi" />
//             <div className={cn(css.ceoDetails)}>
//               <p className={cn(css.ceoName, 'font-semibold')}>{_t('ceo.name')}</p>
//               <p className={cn(css.ceoRole)}>{_t('ceo.role')}</p>
//             </div>
//           </div>
//           <div>
//             <p
//               className={cn(css.ceoTitle, css.textTitle, 'font-semibold')}
//               dangerouslySetInnerHTML={{ __html: _t('ceo.title') }}
//               id="ceoTitle"
//             ></p>
//             <p>{_t('ceo.description')}</p>
//             <a href="https://storycards.com/gil-rabbi" target="_blank" className={css.readMore}>
//               {_t('ceo.readMore')}
//             </a>
//           </div>
//         </div>
//       </section>
//       {/* <section className={css.team}>
//         <p className={cn(css.teamTitle, css.textTitle, "font-semibold")}>
//           {_t("team.title")}
//         </p>
//         <div className={cn(css.teamGrid)}>
//           {teamMembers.map((member) => (
//             <div
//               className={cn(css.teamMember, "flex", "items-center")}
//               key={member.name}
//             >
//               <img
//                 className={css.memberPic}
//                 src={member.pic}
//                 alt="Team member"
//               />
//               <div>
//                 <p className="font-semibold">{member.name}</p>
//                 <p>{member.role}</p>
//               </div>
//             </div>
//           ))}
//           <a
//             href="mailto:careers@storycards.com"
//             className={cn(css.teamMember, css.joinUs, "flex", "items-center")}
//           >
//             <div
//               className={cn(
//                 css.memberPic,
//                 "flex",
//                 "items-center",
//                 "justify-center"
//               )}
//             >
//               <svg
//                 viewBox="0 0 50 50"
//                 version="1.1"
//                 xmlns="http://www.w3.org/2000/svg"
//               >
//                 <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
//                   <g transform="translate(-767.000000, -3432.000000)">
//                     <g
//                       transform="translate(750.000000, 3415.000000)"
//                       opacity="0.773585002"
//                     >
//                       <g transform="translate(-0.000000, -0.000000)">
//                         <polygon points="0 0 84 0 84 84 0 84" />
//                         <g
//                           opacity="0.5"
//                           transform="translate(21.000000, 21.000000)"
//                           fill="#FFFFFF"
//                         >
//                           <path d="M24.5,0 L24.5,17.5 L42,17.5 L42,24.5 L24.5,24.5 L24.5,42 L17.5,42 L17.5,24.5 L0,24.5 L0,17.5 L17.5,17.5 L17.5,0 L24.5,0 Z" />
//                         </g>
//                         <path
//                           d="M49,17.5 L48.999,35 L66.5,35 L66.5,49 L48.999,49 L49,66.5 L35,66.5 L34.999,49 L17.5,49 L17.5,35 L34.999,35 L35,17.5 L49,17.5 Z M45.5,21 L38.5,21 L38.499,38.5 L21,38.5 L21,45.5 L38.499,45.5 L38.5,63 L45.5,63 L45.499,45.5 L63,45.5 L63,38.5 L45.499,38.5 L45.5,21 Z"
//                           fill="#FFFFFF"
//                         />
//                       </g>
//                     </g>
//                   </g>
//                 </g>
//               </svg>
//             </div>
//             <p className={cn(css.textTitle, "font-semibold")}>
//               {_t("team.join")}
//             </p>
//           </a>
//         </div>
//       </section> */}
//     </PageLayout>
//   );
// };

function About() {
  return (
    <PageLayout isFullWidth isWhiteHeader isMarketingHeader showFooterCta={false}>
      <main className={css.page}>
        <section className={css.hero}>
          <div className={css.inner}>
            <p className={css.eyebrow}>Our mission</p>
            <h1>
              Give every team the freedom to create.
              <br />
              Keep the organization in control.
            </h1>
            <div className={css.heroBottom}>
              <p>
                Storycards is building the operating layer for enterprise interactive experiences: one platform
                to create, manage and continuously improve pixel-perfect digital products across teams, brands
                and markets.
              </p>
              <div className={css.actions}>
                <a href={ENTERPRISE_CONTACT_LINK} className={css.primaryButton}>
                  Talk to our enterprise team <span aria-hidden="true">→</span>
                </a>
              </div>
            </div>

            <div className={css.proofStrip} aria-label="Storycards company experience">
              <div>
                <strong>20+ years</strong>
                <span>Of enterprise digital product expertise</span>
              </div>
              <div>
                <strong>Since 2018</strong>
                <span>Turning engagement expertise into one platform</span>
              </div>
              <div>
                <strong>Enterprise-first</strong>
                <span>Built around governance, data and scale</span>
              </div>
            </div>
          </div>
        </section>

        <section className={css.thesis}>
          <div className={`${css.inner} ${css.split}`}>
            <h2>Creation is becoming instant. Operating at enterprise scale is not.</h2>
            <div className={css.bodyCopy}>
              <p>
                AI is removing the barriers to digital creation. But for enterprises, building is only the
                beginning.
              </p>
              <p>
                Organizations still need to protect their brand, control permissions, connect data, manage large
                product portfolios and continuously improve performance. Storycards was built for that reality.
              </p>
            </div>
          </div>
        </section>

        <section className={css.journey}>
          <div className={css.inner}>
            <div className={css.sectionHeading}>
              <p className={css.eyebrow}>Our journey</p>
              <h2>Built from real enterprise problems.</h2>
            </div>
            <div className={css.timeline}>
              {journey.map((item) => (
                <article key={item.year}>
                  <span>{item.year}</span>
                  <h3>{item.title}</h3>
                  <p>{item.text}</p>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className={css.platform}>
          <div className={css.inner}>
            <div className={`${css.sectionHeading} ${css.platformHeading}`}>
              <p className={css.eyebrow}>What we are building</p>
              <h2>More than a creation tool.</h2>
              <p>
                A complete operating system for the products organizations launch, manage and improve every day.
              </p>
            </div>
            <div className={css.pillars}>
              {platformPillars.map((pillar) => (
                <article key={pillar.title}>
                  <span>{pillar.number}</span>
                  <h3>{pillar.title}</h3>
                  <p>{pillar.text}</p>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className={css.vision}>
          <div className={css.inner}>
            <p className={css.eyebrow}>Our vision</p>
            <h2>Every digital product should get better after it launches.</h2>
            <div className={css.visionCopy}>
              <p>
                We envision a future where enterprise experiences are not static deliverables. They understand
                their audience, learn from every interaction and continuously improve.
              </p>
              <p>
                Storycards brings AI speed, professional design control, organizational governance and measurable
                performance into one system, while every experience remains secure and fully aligned with the
                organization behind it.
              </p>
            </div>
          </div>
        </section>

        <section className={css.leadership}>
          <div className={css.inner}>
            <div className={`${css.sectionHeading} ${css.leadershipHeading}`}>
              <p className={css.eyebrow}>Leadership</p>
              <h2>The people leading Storycards.</h2>
            </div>

            <div className={css.leaders}>
              <article id="lior-aran">
                <img src="/lior-aran.png" alt="Lior Aran, Co-Founder and CEO of Storycards" />
                <div className={css.leaderCopy}>
                  <p className={css.role}>Co-Founder &amp; CEO</p>
                  <h3>Lior Aran</h3>
                  <p>
                    Lior leads Storycards&apos; business strategy, operations and global growth. He brings extensive
                    experience in strategy, commerce and building teams that turn technological innovation into
                    measurable business value.
                  </p>
                  <a href="https://www.linkedin.com/in/lior-aran-a3468219/" target="_blank" rel="noopener noreferrer">
                    View Lior on LinkedIn <span aria-hidden="true">↗</span>
                  </a>
                </div>
              </article>

              <article id="gil-rabbi">
                <img src={gilRabbiImage} alt="Gil Rabbi, Founder of Storycards" />
                <div className={css.leaderCopy}>
                  <p className={css.role}>Founder</p>
                  <h3>Gil Rabbi</h3>
                  <p>
                    Gil founded Storycards and leads its product and technology vision. For more than two decades,
                    he has built interactive products for television, live events and digital audiences.
                  </p>
                  <a href={GIL_ROUTE}>
                    Read Gil Rabbi&apos;s story <span aria-hidden="true">→</span>
                  </a>
                </div>
              </article>
            </div>
          </div>
        </section>

        <section className={css.finalCta}>
          <div className={`${css.inner} ${css.finalCtaInner}`}>
            <h2>Build the next generation of enterprise digital experiences.</h2>
            <div>
              <p>Bring creation, governance, data and continuous improvement into one platform.</p>
              <a href={ENTERPRISE_CONTACT_LINK} className={css.primaryButton}>
                Talk to our enterprise team <span aria-hidden="true">→</span>
              </a>
            </div>
          </div>
        </section>
      </main>
    </PageLayout>
  );
}

export default About;
